// Add reaction actions
export const REQUEST_ADD_REACTION = 'REQUEST_ADD_REACTION';
export const FAIL_ADD_REACTION = 'FAIL_ADD_REACTION';
export const SUCCESS_ADD_REACTION = 'SUCCESS_ADD_REACTION';

// Remove reaction actions
export const REQUEST_REMOVE_REACTION = 'REQUEST_REMOVE_REACTION';
export const FAIL_REMOVE_REACTION = 'FAIL_REMOVE_REACTION';
export const SUCCESS_REMOVE_REACTION = 'SUCCESS_REMOVE_REACTION';
// Manage reaction animation state
export const SET_REACTION_SHOULD_ANIMATE_IN = 'SET_REACTION_SHOULD_ANIMATE_IN';
export const SET_REACTION_SHOULD_ANIMATE_OUT = 'SET_REACTION_SHOULD_ANIMATE_OUT';

/**
 * Add contentReaction actions
 * Allows entire contentReaction records to be added to the store
 */
export const ADD_CONTENT_REACTION = 'ADD_CONTENT_REACTION';

// Fetch reaction users
export const REQUEST_REACTION_USERS = 'REQUEST_REACTION_USERS';
export const FAIL_RECEIVE_REACTION_USERS = 'FAIL_RECEIVE_REACTION_USERS';
export const RECEIVE_REACTION_USERS = 'RECEIVE_REACTION_USERS';
export const FINISHED_REACTION_USERS = 'FINISHED_REACTION_USERS';

// Fetch tag users
export const REQUEST_TAG_USERS = 'REQUEST_TAG_USERS';
export const FAIL_RECEIVE_TAG_USERS = 'FAIL_RECEIVE_TAG_USERS';
export const RECEIVE_TAG_USERS = 'RECEIVE_TAG_USERS';
export const FINISHED_TAG_USERS = 'FINISHED_TAG_USERS';

// Fetch current user details
export const REQUEST_CURRENT_USER_DETAILS = 'REQUEST_CURRENT_USER_DETAILS';
export const FAIL_RECEIVE_CURRENT_USER_DETAILS = 'FAIL_RECEIVE_CURRENT_USER_DETAILS';
export const RECEIVE_CURRENT_USER_DETAILS = 'RECEIVE_CURRENT_USER_DETAILS';

// Follow user
export const REQUEST_FOLLOW_USER = 'REQUEST_FOLLOW_USER';
export const FAIL_FOLLOW_USER = 'FAIL_FOLLOW_USER';
export const SUCCESS_FOLLOW_USER = 'SUCCESS_FOLLOW_USER';

// Unfollow user
export const REQUEST_UNFOLLOW_USER = 'REQUEST_UNFOLLOW_USER';
export const FAIL_UNFOLLOW_USER = 'FAIL_UNFOLLOW_USER';
export const SUCCESS_UNFOLLOW_USER = 'SUCCESS_UNFOLLOW_USER';

// Set user follow
export const SET_USER_FOLLOW = 'SET_USER_FOLLOW';

// Suggested
export const SUCCESS_GET_SUGGESTED_ATHLETES = 'SUCCESS_GET_SUGGESTED_ATHLETES';
export const SUCCESS_GET_TEAMMATES = 'SUCCESS_GET_TEAMMATES';
export const SUCCESS_MODAL_GET_SUGGESTED_ATHLETES = 'SUCCESS_MODAL_GET_SUGGESTED_ATHLETES';
export const UPDATE_FOLLOWING_STATUS = 'UPDATE_FOLLOWING_STATUS';
export const UPDATE_IS_FETCHING_ATHLETES = 'UPDATE_IS_FETCHING_ATHLETES';
export const UPDATE_IS_FETCHING_SUGGESTIONS = 'UPDATE_IS_FETCHING_SUGGESTIONS';
export const UPDATE_SHOW_TEAMMATES_STATUS = 'UPDATE_SHOW_TEAMMATES_STATUS';
export const UPDATE_SHOW_ONBOARDING_BEACON = 'UPDATE_SHOW_ONBOARDING_BEACON';
export const FAIL_RECEIVE_SUGGESTED_ATHLETES = 'FAIL_RECEIVE_SUGGESTED_ATHLETES';
export const FAIL_FOLLOW_TEAM = 'FAIL_FOLLOW_TEAM';
export const FAIL_UNFOLLOW_TEAM = 'FAIL_UNFOLLOW_TEAM';
export const UPDATE_SHOULD_REFRESH_SUGGESTIONS = 'UPDATE_SHOULD_REFRESH_SUGGESTIONS';
export const UPDATE_DISPLAY_SUGGESTIONS_MODAL = 'UPDATE_DISPLAY_SUGGESTIONS_MODAL';
export const SHOULD_UPDATE_FOLLOWING_STATUS = 'SHOULD_UPDATE_FOLLOWING_STATUS';
export const UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS = 'UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS';
export const UPDATE_HAS_MORE_SUGGESTIONS = 'UPDATE_HAS_MORE_SUGGESTIONS';

// Dismiss Feed Cards
export const REQUEST_DISMISS_FEED_ITEM = 'REQUEST_DISMISS_FEED_ITEM';
export const FAIL_DISMISS_FEED_ITEM = 'FAIL_DISMISS_FEED_ITEM';
export const SUCCESS_DISMISS_FEED_ITEM = 'SUCCESS_DISMISS_FEED_ITEM';

// Recruiter Activity
export const SUCCESS_GET_RECRUITER_ACTIVITY = 'SUCCESS_GET_RECRUITER_ACTIVITY';
export const UPDATE_IS_FETCHING_RECRUITER_ACTIVITY = 'UPDATE_IS_FETCHING_RECRUITER_ACTIVITY';
export const FAIL_GET_RECRUITER_ACTIVITY = 'FAIL_GET_RECRUITER_ACTIVITY';
export const UPDATE_DISPLAY_VIEW_ALL_MODAL = 'UPDATE_DISPLAY_VIEW_ALL_MODAL';
export const UPDATE_HAS_MORE_ACTIVITY = 'UPDATE_HAS_MORE_ACTIVITY';
export const SUCCESS_MODAL_GET_RECRUITER_ACTIVITY = 'SUCCESS_MODAL_GET_RECRUITER_ACTIVITY'
export const UPDATE_IS_FETCHING_RECRUITER_ACTIVITY_MODAL = 'UPDATE_IS_FETCHING_RECRUITER_ACTIVITY_MODAL';
